"use client";

import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import type { QRProps } from "@/contexts/QREditorContext/types";
import { PreviewSource } from "@/components/QRPreview/types";
import type { QRDataType } from "@/types/qr";

import type { PreviewAdapterProps } from "../components/PreviewAdapter";

const UNPREVIEWABLE_QR_TYPES = ["url", "wifi", "image", "text", "whatsapp"];

export type UseViewPreviewRenderArgsParams = {
  qrData: QRProps<QRDataType>;
  language: string;
};

/**
 * `/p` and /qr view: builds props for PreviewAdaptger — translations from i18n resources,
 * `preview` flag for types that skip “preview mode”, and PreviewSource.previewPage.
 */
export const useViewPreviewRenderArgs = ({
  qrData,
  language,
}: UseViewPreviewRenderArgsParams): PreviewAdapterProps | null => {
  const { i18n } = useTranslation();

  const previewTranslations = useMemo(() => i18n.options.resources?.[language], [i18n, language]);

  const qrType = qrData?.type || "";

  if (!qrType) {
    return null;
  }

  const preview = !UNPREVIEWABLE_QR_TYPES.includes(qrType);

  return {
    ...qrData,
    previewTranslations,
    preview,
    source: PreviewSource.previewPage,
  } as PreviewAdapterProps;
};
